import { makeStyles } from "@material-ui/core/styles";

export const useSearchInputStyles = makeStyles(theme => ({
  root: {
    padding: "0 25px",
    height: 50,
    fontSize: 12,
    backgroundColor: "#fff"
  },

  input: {
    "&::placeholder": {
      color: theme.palette.grey[500]
    }
  },

  icon: {
    color: theme.palette.grey[300],
    marginRight: 10
  },

  clearBtn: {
    marginLeft: "auto"
  }
}));
